import script from "./ViewMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewMain.vue?vue&type=script&setup=true&lang=ts"

import "./ViewMain.vue?vue&type=style&index=0&id=331a1220&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331a1220"]])

export default __exports__